export const MODEL_ROUTE = '/lots';
